import { post } from '../api/client';
import type { SiteRef } from '../api/types';

/** §28 the colours offered for a new site. */
export const SITE_COLORS = ['#5AA9E6', '#F0A04B', '#B58CF0', '#4CB782', '#E5534B', '#2BB3A3', '#D9C25B'];

/** Move robots to a site (null = no site); the robot list updates over /ws/ui. */
export async function assignSite(serials: string[], siteId: string | null) {
  return post<{ site: SiteRef | null; serials: string[] }>('/api/sites/assign', { serials, siteId });
}
